import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCfpAuthUtilities } from '../providers/CfpAuthContext';
import { getUpdatedConfig } from '../config/env';
import Loading from '../components/common/Loading';
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";

import UserAuthorizationCheck from '../api/userAuthorizationCheck';
import logger from '../utils/logger';

export default function RedirectPage() {
  const { cfpAuthUtils  } = useCfpAuthUtilities();
  const navigate = useNavigate();
  const authorizationAttempted = useRef(false);

  useEffect(() => {
    const checkUserAuthorization = async () => {
      // Prevent duplicate calls from React Strict Mode or component re-renders
      if (authorizationAttempted.current) {
        logger.info('🔄 Authorization already attempted, skipping duplicate call');
        return;
      }
      
      authorizationAttempted.current = true;
      
      try {
        await cfpAuthUtils.initialize(getUpdatedConfig());
        
        // checkLoginAfterCallback now returns the authorization result directly
        const authResult = await cfpAuthUtils.checkLoginAfterCallback();
        
        if (authResult) {
          // Check if result is an error or user info
          if (UserAuthorizationCheck.IsError(authResult)) {

            console.error('Authorization Error:', authResult.code, authResult.message);
            
            // Check if user is not a group member - redirect to access denied page
            if (authResult.code === 'REQUEST_FAILED') {
              console.log('🚫 User not authorized - redirecting to access denied page');
              navigate('/access-denied');
            } else {
              // Redirect to error page for other authorization failures
              navigate('/error');
            }
          } else {
            logger.info('✅ Authorization successful:', authResult);
            // User info is already cached by checkLoginAfterCallback
            // Redirect to home page on authorization success
            navigate('/home');
          }
        } else {
          console.log('⚠️ No authorization result - user not logged in or authentication failed');
          // Redirect to error page if no result is available
          navigate('/error');
        }
      } catch (error) {
        console.error('Error in authorization check:', error instanceof Error ? error.message : String(error));
        // Redirect to error page on any error
        navigate('/error');

      }
    };

   
    checkUserAuthorization();
    
  }, [cfpAuthUtils, navigate]); // Removed loading and isAuthenticated to prevent re-triggers

  return (
    <DHBox sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <Loading message="Processing your request, please wait..." />
    </DHBox>
  );
}